import EditShippingAddressDialog from "@/pages/(app)/returns/view/components/edit-shipping-address/edit-shipping-address-dialog";
import type { ReturnRequestDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { HouseIcon } from "lucide-react";

type ShippingAddress = {
  returnRequest: ReturnRequestDto;
};

export default function ShippingAddress({ returnRequest }: ShippingAddress) {
  const t = useTranslation();
  const { shipping_address: shippingAddress } = returnRequest;

  const name = shippingAddress.first_name + " " + shippingAddress.last_name;

  return (
    <div className="group">
      <div className={"flex flex-row items-center justify-between"}>
        <h2 className="text-sm font-medium text-gray-500 inline-flex items-center gap-2">
          <HouseIcon className="size-3" />
          {t("misc.shippingAddress")}
        </h2>
        <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <EditShippingAddressDialog
            returnRequest={returnRequest}
            key={returnRequest.id}
          />
        </div>
      </div>
      <div className={"flex flex-col gap-1 text-sm font-regular text-gray-900"}>
        <span className="font-medium">{name}</span>
        <span>{shippingAddress.address1}</span>
        <span>{shippingAddress.address2}</span>
        <span>{`${shippingAddress.zip} ${shippingAddress.city}`}</span>
        <span>{shippingAddress.country}</span>
      </div>
    </div>
  );
}
